import { MemberProfile } from "@/services/core-api-adapter";
import AdditionalPayGServicesSection from ".";
import { Stack, Typography } from "@mui/material";
import {
  defaultFullscreenPageStyling,
  pageWithBottomNavigationStyling,
} from "@/theme";

export default function AdditionalPayGServicesExamples() {
  return (
    <Stack
      sx={{
        ...defaultFullscreenPageStyling,
        ...pageWithBottomNavigationStyling,
        position: "relative",
      }}
    >
      <AdditionalPayGServicesSection
        isMemberProfileLoading={false}
        memberProfileFetchError={false}
        memberProfile={
          {
            firstName: "Susan",
            consultation: {
              isDiscountApplied: false,
              consultationResponses: [],
              consultationRates: [
                {
                  offeringId: "683d9c2e-5afe-4dd5-99aa-f969d2ae0d4e",
                  chargeCode: "DIGITAL_DOCTOR_CONSULT",
                  isDiscountApplied: false,
                  discountAmount: 0.0,
                  amount: 249.0,
                  amountFormatted: "R249.00",
                  originalAmount: 249.0,
                  originalAmountFormatted: "R249.00",
                  ussdConfiguration: null,
                  isFeatured: false,
                },
                {
                  offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
                  chargeCode: "ONLINE_DOCTOR_CONSULTATION",
                  isDiscountApplied: false,
                  discountAmount: 0.0,
                  amount: 189.0,
                  amountFormatted: "R189.00",
                  originalAmount: 189.0,
                  originalAmountFormatted: "R189.00",
                  ussdConfiguration: null,
                  isFeatured: false,
                },
                {
                  offeringId: "51bdccec-6009-495b-9e63-2a0faf68d015",
                  chargeCode: "CHAT_TO_A_NURSE",
                  isDiscountApplied: false,
                  discountAmount: 0.0,
                  amount: 95.0,
                  amountFormatted: "R95.00",
                  originalAmount: 95.0,
                  originalAmountFormatted: "R95.00",
                  ussdConfiguration: null,
                  isFeatured: false,
                },
              ],
            },
            pathology: {
              chargeCode: "BLOOD_WORK",
              isDiscountApplied: false,
              discountAmount: 0,
              amount: 18000,
              originalAmount: 18000,
              currencyCode: "ZAR",
            },
            voucher: {
              isDiscountApplied: false,
              vendorId: "e6f93150-89e5-46db-8796-c26692efa9cd",
              rates: [
                {
                  chargeCode: "PATH_STD_INCL_HIV",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 115700,
                  originalAmount: 115700,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_HBA1C",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 18000,
                  originalAmount: 18000,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_CHOLESTEROL",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 38600,
                  originalAmount: 38600,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "ONLINE_DOCTOR_CONSULTATION",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 18900,
                  originalAmount: 18900,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_BP",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 21200,
                  originalAmount: 21200,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_STD_PCR",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 67400,
                  originalAmount: 67400,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_FEMALE",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 42800,
                  originalAmount: 42800,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_HIV_MONITORING",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 88000,
                  originalAmount: 88000,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_DIABETES",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 52300,
                  originalAmount: 52300,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_ANTENATAL",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 21200,
                  originalAmount: 21200,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_HIV_SCREENING",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 21100,
                  originalAmount: 21100,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_MALE_OVER_45",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 55400,
                  originalAmount: 55400,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_HEPATITIS_B",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 20100,
                  originalAmount: 20100,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_MALE_UNDER_45",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 42800,
                  originalAmount: 42800,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_ANAEMIA",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 29000,
                  originalAmount: 29000,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_VIRAL_LOAD",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 75800,
                  originalAmount: 75800,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_SYPHILIS",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 20100,
                  originalAmount: 20100,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "PATH_STD_EXCL_HIV",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 99000,
                  originalAmount: 99000,
                  currencyCode: "ZAR",
                },
                {
                  chargeCode: "DIGITAL_DOCTOR_CONSULT",
                  isDiscountApplied: false,
                  discountAmount: 0,
                  amount: 24900,
                  originalAmount: 24900,
                  currencyCode: "ZAR",
                },
              ],
            },
            memberServiceOfferingUsageCount: "1",
            healthProfile: {
              lastUpdatedAt: "2022-07-08T10:26:04Z",
              healthScoreValue: 0,
            },
            benefitCount: 11,
            dependentCount: 1,
            membership: {
              id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
              fullName: "Susan",
              beneficiaryCode: "00",
              productCode: "UNU01",
              productFriendlyName: "Unu forFree",
              membershipNumber: "UNU-725",
              dependentCount: 1,
              status: "ACTIVE",
            },
            product: {
              pharmacySwitchCode: null,
              provider: null,
              administrator: {
                id: "38d556f7-5302-4ea7-a1a4-660371b7d953",
                code: "NHG",
                name: "National Health Group",
                FileUri: "FileUri",
                timeZone: "UTC+02:00",
                supportedServices: [
                  {
                    type: "CALL_CENTRE",
                    channels: [
                      {
                        type: "PHONE",
                        value: "+27860222286",
                        availability: [],
                      },
                      {
                        type: "EMAIL",
                        value: "test@test.com",
                        availability: [],
                      },
                      {
                        type: "WHATSAPP",
                        value: null,
                        availability: [],
                      },
                    ],
                  },
                ],
              },
            },
            serviceOfferings: [
              {
                id: "ec461bc2-6343-4d31-ae08-f998267db001",
                description: "CONSULTATIONS",
                offerings: [
                  {
                    offeringId: "683d9c2e-5afe-4dd5-99aa-f969d2ae0d4e",
                    chargeCode: "DIGITAL_DOCTOR_CONSULT",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 24900,
                    originalAmount: 24900,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "4f24e185-2534-47e9-ac67-95b179c5f4cf",
                    chargeCode: "ONLINE_DOCTOR_CONSULTATION",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 18900,
                    originalAmount: 18900,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                ],
              },
              {
                id: "39270a58-15d9-4e5b-8a6b-f54081c282fb",
                description: "PATHOLOGY",
                offerings: [
                  {
                    offeringId: "122bb0ff-cd68-402e-a6ce-7f66cacc869a",
                    chargeCode: "PATH_STD_EXCL_HIV",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 99000,
                    originalAmount: 99000,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "00eb8796-ac37-496e-aecc-1fac68ed2211",
                    chargeCode: "PATH_VIRAL_LOAD",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 75800,
                    originalAmount: 75800,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "488cf288-44dc-4a7a-9f16-e878e71ba9ef",
                    chargeCode: "PATH_HEPATITIS_B",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 20100,
                    originalAmount: 20100,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "5fd39c79-26ca-4635-b86a-81500d3343f7",
                    chargeCode: "PATH_DIABETES",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 52300,
                    originalAmount: 52300,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "192878d4-0a7d-4481-b193-3382da78e5d3",
                    chargeCode: "PATH_STD_PCR",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 67400,
                    originalAmount: 67400,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "c9759cb8-052a-4f01-9ec1-81342898e0d9",
                    chargeCode: "PATH_ANTENATAL",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 21200,
                    originalAmount: 21200,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "7d87b969-5991-4664-b33b-dd4b7db5d306",
                    chargeCode: "PATH_BP",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 21200,
                    originalAmount: 21200,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "ccba2c3a-bbb5-4300-bfe9-c0e51a992d66",
                    chargeCode: "PATH_FEMALE",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 42800,
                    originalAmount: 42800,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "8406d19f-fe2a-4273-8540-c9d7b4ec157b",
                    chargeCode: "PATH_MALE_UNDER_45",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 42800,
                    originalAmount: 42800,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "30cb47f4-a4c7-4a7c-8a61-adf446573997",
                    chargeCode: "PATH_HIV_SCREENING",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 21100,
                    originalAmount: 21100,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "cfede163-23dd-4f75-b3f6-ae42cb8310ec",
                    chargeCode: "PATH_CHOLESTEROL",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 38600,
                    originalAmount: 38600,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "162fa0d5-525d-4b06-b696-1bc0a9aab8dc",
                    chargeCode: "PATH_SYPHILIS",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 20100,
                    originalAmount: 20100,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "865eb4bb-5b80-4988-9dfb-2d0423a4fc29",
                    chargeCode: "PATH_HIV_MONITORING",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 88000,
                    originalAmount: 88000,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "950a8850-fdc4-4bd0-b64d-80f772de2a72",
                    chargeCode: "PATH_STD_INCL_HIV",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 115700,
                    originalAmount: 115700,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "57e57183-884d-4843-be4a-fbbaeb61f623",
                    chargeCode: "PATH_MALE_OVER_45",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 55400,
                    originalAmount: 55400,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "5ae2adc4-3a5c-4e35-80a8-ef0a04a26477",
                    chargeCode: "PATH_ANAEMIA",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 29000,
                    originalAmount: 29000,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                  {
                    offeringId: "b49744ab-3a82-4ccc-b49c-614f49bb307c",
                    chargeCode: "PATH_HBA1C",
                    isDiscountApplied: false,
                    discountAmount: 0,
                    amount: 18000,
                    originalAmount: 18000,
                    currencyCode: "ZAR",
                    isFeatured: true,
                  },
                ],
              },
            ],
          } as unknown as MemberProfile
        }
      />
    </Stack>
  );
}
